import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, pairwise } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private excludedUrl = ['/login', '/registration/', '/forgot-password', 'change-password'];
  private previousUrl: string;

  currentState: Subject<any> = new Subject();
  currentValue = new BehaviorSubject<any>({});
  getValue = this.currentValue.asObservable();

  public toggleStatusSubject = new BehaviorSubject<boolean>(false);
  toggleStatus$ = this.toggleStatusSubject.asObservable();

  private previousUrlSubject = new BehaviorSubject<string>('');
  private routeDataSubject = new BehaviorSubject<any>('');

  previousUrl$ = this.previousUrlSubject.asObservable();
  routeData$ = this.routeDataSubject.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
      });
  }

  addValue(key: string, value: string) {
    this.currentState.next({ key, value });
  }

  setValue(key: string, value: string) {
    this.currentValue.next({ key, value });
  }

  canNavigateBack() {
    return this.previousUrl && !this.excludedUrl.some(url => this.previousUrl.startsWith(url));
  }

  toggleStatus(status) {
    this.toggleStatusSubject.next(status);
  }
}
